// removed by extract-text-webpack-plugin
module.exports = {"labelTypography":"_1imkD","smallLinkTypography":"_22UCj","titleTypography":"_1qXIz","cardTitleTypography":"_14IyJ","nameCell":"_22lFX","truncate":"_1BIKT","base":"_2mQOX","statusWarnings":"_3hkVS","statusSuccess":"_1XszM","statusError":"yaS-s","subHeadingStyle":"_3sOza","noBeneficiary":"_o7wt","buttonAction":"_25Khx","buttonLeft":"_1mBp7","buttonRight":"_1vr_E","buttonBorder":"_3SSCP","buttonContainer":"_2Vf5d","flexDirection":"_1LbLI","buttonElement1":"qEcHj","buttonElement2":"A0cTL","buttonElement3":"_3CjS5","buttonElement4":"_2lM2S"};


//////////////////
// WEBPACK FOOTER
// ./src/views/Beneficiaries/components/Beneficiary/BeneficiaryList.scss
// module id = 773
// module chunks = 0